import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ConfigurationParameter, ConfigurationParamUpdate } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseMutationOptions<unknown, Error, ConfigurationParamUpdate, ConfigurationParameter>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useEditConfigurationParamRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, ConfigurationParamUpdate, ConfigurationParameter>(
    [Entities.Configuration, 'edit', id],
    async (payload: ConfigurationParamUpdate) => {
      const { data } = await api.v1AdminConfigurationConfigParamIdPut(
        id,
        payload,
      )
      return data
    },
    {
      ...options,
    },
  )
}
